import { z } from "zod";

export type StorageSortBy = "createdAt" | "name";
export const zStorageSortBy = z.enum(["createdAt", "name"]);
export type StorageOrderBy = "asc" | "desc";
export const zStorageOrderBy = z.enum(["asc", "desc"]);
export type StorageFilterByType = "all" | "videos" | "presentations" | "lomdas" | "lomdasV2" | "lomdasV3";
export const zStorageFilterByType = z.enum(["all", "videos", "presentations", "lomdas", "lomdasV2", "lomdasV3"]);
export const storageResultsPerPageOptions = [8, 16, 24, 48, 96];

export interface BaseQuery {
    search: string;
    page: number;
    resultsPerPage: number;
    orderBy: StorageOrderBy;
    sortBy: StorageSortBy;
}
export interface FoldersQuery extends BaseQuery {}
export interface FilesQuery extends BaseQuery {
    filterBy: StorageFilterByType;
}

export const DEFAULT_FOLDERS_QUERY: FoldersQuery = {
    search: "",
    page: 1,
    resultsPerPage: 8,
    orderBy: "desc",
    sortBy: "createdAt",
};
export const DEFAULT_FILES_QUERY: FilesQuery = {
    ...DEFAULT_FOLDERS_QUERY,
    filterBy: "all",
};

type Option<T> = {
    value: T;
    keyName: string;
    defaultValue: string;
};

export const storageOrderByOptions: Option<StorageOrderBy>[] = [
    {
        value: "desc",
        keyName: "storage.order-options.desc",
        defaultValue: "יורד",
    },
    {
        value: "asc",
        keyName: "storage.order-options.asc",
        defaultValue: "עולה",
    },
];

export const storageSortByOptions: Option<StorageSortBy>[] = [
    {
        value: "createdAt",
        keyName: "storage.sort-options.created-at",
        defaultValue: "נוצר בתאריך",
    },
    {
        value: "name",
        keyName: "storage.sort-options.name",
        defaultValue: "שם",
    },
];

export const storageFilterByTypeOptions: Option<StorageFilterByType>[] = [
    {
        value: "all",
        keyName: "storage.filter-by-type-options.all",
        defaultValue: "הכל",
    },
    {
        value: "videos",
        keyName: "storage.filter-by-type-options.videos",
        defaultValue: "סרטונים",
    },
    {
        value: "presentations",
        keyName: "storage.filter-by-type-options.presentations",
        defaultValue: "מצגות",
    },
    {
        value: "lomdas",
        keyName: "storage.filter-by-type-options.lomdas",
        defaultValue: "לומדות",
    },
    {
        value: "lomdasV2",
        keyName: "storage.filter-by-type-options.lomdas-v2",
        defaultValue: "לומדות וידאו",
    },
    {
        value: "lomdasV3",
        keyName: "storage.filter-by-type-options.lomdas-v3",
        defaultValue: "לומדות HTML",
    },
];
